import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, FormHelperText, FormControl } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { AddThirdPartyDeviceConfigurationThunk, getThirdPartyDevices } from "../../store/thunk/thirdPartyDeviceThunk";
import LocationSelector, { HandleSelectionReturnType, Locations } from "../common/LocationSelector";

export default function ConfigureDialog({ open, handleClose, selectedProvider, tenant, configuredDevice, initialValue }: any) {

    const [configData, setconfigData] = useState<any>({
        system: "",
        facility: "",
        floor: "",
        room: ""
    });

    const [validateError, setvalidateError] = useState<any>([]);
    const [locationName, setLocationName] = useState<any>("");
    const { loader } = useAppSelector((state) => state.thirdPartyDeviceSlice);
    const dispatch = useAppDispatch();

    const handleSaveConfiguration = async () => {

        const error = validateTenant();
        if (error.length == 0) {
            // Here, dispatch a thunk or update state with configuration changes as needed.
            await dispatch(AddThirdPartyDeviceConfigurationThunk({
                deviceId: configuredDevice?.deviceId,
                flr: configData?.floor,
                fcl: configData?.facility,
                loc: configData?.room,
                location_name: locationName,
                providerId: selectedProvider?.sk,
                provider: selectedProvider?.provider,
                stm: configData?.system,
                tenantCode: tenant?.tenantCode
            }));
            await dispatch(getThirdPartyDevices({ providerId: selectedProvider?.sk }));
            handleClose();
        };
    }

    const handleSelection = (locations?: HandleSelectionReturnType) => {
        setconfigData((prev: any) => ({
            ...prev,
            system: locations?.system?.value,
            facility: locations?.facility?.value,
            floor: locations?.floor?.value,
            room: locations?.room?.value,
        }))
    }

    const validateTenant = () => {
        let error: any = [];

        if (!configData?.facility) {
            error.push("facility");
        }
        if (!locationName) {
            error.push("locationName");
        }
        if (
            !configData?.floor
        ) {
            error.push("floor");
        }
        if (!configData?.room) {
            error.push("room");
        }

        setvalidateError(error);

        return error;
    }


    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', pb: 1 }}>Configure Device</DialogTitle>
            <DialogContent dividers>
                {configuredDevice && (
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            margin="dense"
                            label="Device ID"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={configuredDevice.deviceId}
                            disabled
                        />
                        <FormControl margin="normal" fullWidth>
                            <TextField
                                margin="dense"
                                label="Tenant"
                                type="text"
                                fullWidth
                                variant="outlined"
                                disabled
                                value={tenant?.tenant_name}
                            />
                        </FormControl>
                        <FormHelperText error={validateError.includes("tenant")}>
                            {validateError.includes("tenant") && "Please select tenant"}
                        </FormHelperText>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Location Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setLocationName(e.target.value)}
                            value={locationName}
                        />
                        <FormHelperText error={validateError.includes("locationName")}>
                            {validateError.includes("locationName") && "Please Add Location Name"}
                        </FormHelperText>

                        <Box sx={{ mt: 2 }}>
                            <LocationSelector
                                initialValue={initialValue}
                                handleSelection={handleSelection}
                                startLevel={Locations.system}
                                endLevel={Locations.room}
                            />
                            <FormHelperText error={validateError.includes("facility")}>
                                {validateError.includes("facility") && "Please select facility / Group"}
                            </FormHelperText>
                            <FormHelperText error={validateError.includes("floor")}>
                                {validateError.includes("floor") && "Please select floor"}
                            </FormHelperText>
                            <FormHelperText error={validateError.includes("room")}>
                                {validateError.includes("room") && "Please select room"}
                            </FormHelperText>

                        </Box>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={handleClose} variant="outlined" color="primary" sx={{ textTransform: 'none' }}>
                    Cancel
                </Button>
                <LoadingButton loading={loader} onClick={handleSaveConfiguration} variant="contained" color="secondary" sx={{ textTransform: 'none' }}>
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
